export const messageRecording = 'Recording...';
export const messageCouldntHear =
  "I couldn't hear you, could you say that again?";
export const messageInternalError =
  'Oh no, there has been an internal server error';
export const messageSorry = "I'm sorry, I don't have the answer to that yet.";

export const CHAT_BOT_DISPLAY =
  'Hello, my name is Simmons!\nNeed a stat? Try asking me questions like, "How many People in US are married?"';
export const CHAT_BOT_SPEECH =
  'There are 38.6 million adults in the U.S.that are Hispanic';
